module.exports = __webpack_public_path__ + "assets/952c1c4db6ded635ccb1f31dae57ac17.png";